import React from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/** Renders the seeker's uploaded palm photo (right-aligned customer bubble). */
const PalmPhotoMessage = ({ payload }) => {
  const url = payload?.original_url;
  if (!url) return null;
  const src = url.startsWith("http") ? url : `${BACKEND}${url}`;
  return (
    <div className="max-w-[60%]">
      <img
        src={src}
        alt="your palm"
        className="rounded-xl border border-soft"
        data-testid="palm-customer-photo"
      />
      <p className="text-[10px] text-muted text-right mt-1">your palm</p>
    </div>
  );
};

export default PalmPhotoMessage;
